import { Box, BoxProps, StyleClosetTheme, theme } from '@betterment/style-closet-react';
import styled from '@emotion/styled';

const HEADER_HEIGHT = theme.space[11];
const HEADER_PADDING = theme.space[8];
const NAV_COLLAPSE_BREAKPOINT = theme.breakpoints[2];
const WHEN_NAV_NOT_COLLAPSED = `@media screen and (min-width: ${NAV_COLLAPSE_BREAKPOINT})`;
export const NavigationContainer = styled('div')`
  height: 100%;
  z-index: 2;
  position: fixed;

  ${WHEN_NAV_NOT_COLLAPSED} {
    position: initial;
  }
`;

export const HiddenWhenCollapsedBox = styled(Box)`
  display: none;

  ${WHEN_NAV_NOT_COLLAPSED} {
    display: initial;
  }
`;

export const NavLink = styled(({ as = 'a', ...props }: BoxProps) => <Box as={as} {...props} />)<
  React.AnchorHTMLAttributes<HTMLAnchorElement> & { active: boolean },
  StyleClosetTheme
>`
  font-size: ${theme.fontSizes[1]};
  line-height: ${theme.lineHeights[1]};
  color: ${theme.colors.bmtWhite} !important;
  display: flex;
  align-items: center;
  background-color: ${({ active }) => active && `${theme.colors.bmtWhite}66`};

  &:hover {
    background-color: ${`${theme.colors.bmtWhite}26`};
  }

  &:focus,
  &:focus-visible {
    border: ${`2px solid ${theme.colors.bmtWhite}`};
    outline: none;
  }

  &:focus,
  &:active,
  &:hover {
    text-decoration: none;
  }
`;

export const ClickAwayOverlay = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: block;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: ${theme.zIndexes.overlay};

  ${WHEN_NAV_NOT_COLLAPSED} {
    display: none;
  }
`;

export const CollapsedHeader = styled('div')`
  background-color: ${theme.colors.bmtNavy};
  text-align: center;
  padding: ${theme.space[6]};
  position: fixed;
  width: 100%;
  height: ${HEADER_HEIGHT};
  z-index: ${theme.zIndexes.overlay};

  ${WHEN_NAV_NOT_COLLAPSED} {
    display: none;
  }
`;

export const Hamburger = styled('div')`
  position: fixed;
  left: 0;
  top: 0;
  height: ${HEADER_HEIGHT};
  padding: ${HEADER_PADDING};
  cursor: pointer;
`;

export const CtaButton = styled('div')`
  position: fixed;
  right: 0;
  top: 0;
  background-color: ${theme.colors.bmtNavy};
  padding: ${HEADER_PADDING};
  height: ${HEADER_HEIGHT};
`;

export const Sidebar = styled('div')<React.HTMLAttributes<HTMLDivElement> & { open: boolean }, StyleClosetTheme>`
  height: 100%;
  padding-bottom: ${theme.space[6]};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: transform 250ms cubic-bezier(0, 0, 0.5, 1);
  background-color: ${theme.colors.bmtNavy};
  z-index: ${theme.zIndexes.modal};

  position: fixed;
  width: 80%;
  max-width: 30rem;
  transform: ${({ open }) => (open ? 'translate3d(0, 0, 0)' : 'translate3d(-100%, 0, 0)')};

  ${WHEN_NAV_NOT_COLLAPSED} {
    position: initial;
    width: initial;
    max-width: initial;
    transform: translate3d(0, 0, 0);
  }
`;

export const SidebarHeader = styled('div')`
  padding: ${HEADER_PADDING};
  display: flex;
  flex-shrink: 0;
  height: ${HEADER_HEIGHT};
  align-items: center;
`;

export const WelcomeMessage = styled(({ as = 'h3', ...props }: BoxProps) => <Box as={as} {...props} />)`
  ${WHEN_NAV_NOT_COLLAPSED} {
    display: none;
  }
`;

export const CloseButton = styled('span')`
  display: block;
  margin-top: ${theme.space[1]};

  ${WHEN_NAV_NOT_COLLAPSED} {
    display: none;
  }
`;

export const CloseClickTarget = styled('div')`
  display: block;
  cursor: pointer;
  position: fixed;
  top: 0;
  left: 0;
  height: ${HEADER_HEIGHT};
  padding: ${HEADER_PADDING};

  ${WHEN_NAV_NOT_COLLAPSED} {
    display: none;
  }
`;

export const LinkContainer = styled('div')`
  flex-grow: 1;
  overflow: auto;
`;
